import { FC, PropsWithChildren, useState } from 'react';
import { useMount } from 'react-use';
import { History, createBrowserHistory } from 'history';
import { IonApp, setupIonicReact, isPlatform } from '@ionic/react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';

import { TextZoom } from '@capacitor/text-zoom';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';

import { THEME, DEFAULT_TEXT_ZOOM } from '../../constants';

import './ThemeProvider.scss';
import './ThemeProvider.css';

export type ThemeProviderProps = PropsWithChildren<{
  history?: History;
}>;

const HISTORY = createBrowserHistory();

setupIonicReact({
  mode: 'md',
  rippleEffect: false,
});

export const ThemeProvider: FC<ThemeProviderProps> = ({
  children,
  history = HISTORY,
}) => {
  const [textZoom, setTextZoom] = useState(DEFAULT_TEXT_ZOOM);

  useMount(() => {
    App.addListener('appUrlOpen', ({ url }: URLOpenListenerEvent) => {
      const { search, pathname } = new URL(url);
      history.push({ pathname, search });
    });
  });

  useMount(() => {
    if (Capacitor.isNativePlatform()) {
      TextZoom.getPreferred().then(({ value }) => {
        setTextZoom(() => value);
      });
    }
  });

  return (
    <StyledThemeProvider
      theme={{
        ...THEME,
        textZoom,
        isTablet: isPlatform('tablet'),
        isDesktop: isPlatform('desktop'),
        isMobile: isPlatform('mobile'),
      }}
    >
      <IonApp>{children}</IonApp>
    </StyledThemeProvider>
  );
};
